import type { z } from 'zod';

import type { ValidationIssue } from './issues.js';

import { toPointer } from './issues.js';

type ZodIssueLike = z.core.$ZodIssue;

const zodIssueToValidationIssue = (issue: ZodIssueLike): ValidationIssue => {
  const path = issue.path.map(p => (typeof p === 'symbol' ? String(p) : p));
  const base = {
    severity: 'error' as const,
    message: issue.message,
    path,
    pointer: toPointer(path),
  };

  switch (issue.code) {
    case 'invalid_value':
      return {
        ...base,
        code: 'shape.invalid-enum',
        currentValue: (issue as { input?: unknown }).input,
        constraint: {
          kind: 'enum',
          allowedValues: issue.values.map(String),
        },
      };
    case 'invalid_type':
      return {
        ...base,
        code: 'shape.invalid',
        constraint: {
          kind: 'shape',
          expectedType: issue.expected,
        },
      };
    case 'too_small':
    case 'too_big':
      return {
        ...base,
        code: issue.code === 'too_small' ? 'shape.too-small' : 'shape.too-big',
        constraint: { kind: 'range', detail: issue.message },
      };
    case 'invalid_union':
      return {
        ...base,
        code: 'shape.invalid-union',
        constraint: { kind: 'shape', detail: issue.message },
      };
    default:
      return {
        ...base,
        code: `shape.${issue.code}`,
        constraint: { kind: 'shape', detail: issue.message },
      };
  }
};

export const zodErrorToIssues = (error: z.ZodError): ValidationIssue[] =>
  error.issues.map(issue => zodIssueToValidationIssue(issue));
